import { createSelector } from 'reselect';
import { rawMatPhraseSelectors } from '../../rawMatPhrase';

const getInitialValues = rawMatPhraseId =>
  createSelector([rawMatPhraseSelectors.getById], rawMatPhraseById => rawMatPhraseById[rawMatPhraseId] || {});

export const makeGetInitialValues = createSelector(getInitialValues, initialValues => initialValues);
